const DEFAULT_DATA = {
  id           : false,
  defaultHref  : false,
  defaultTarget: false,
};



export default {
  props: {
    disabled: Boolean,

    linkset: {
      type: [String, Object],
      default: null,
    },

    href: {
      type: String,
      default: 'javascript:void(0);',
    },

    target: {
      type: String,
      default: '_self',
    },
  },



  computed: {
    hasLinkData() { return !!this.linkset },

    linkData() {
      const assignData = typeof this.linkset === 'string' ? {id: this.linkset} : this.linkset;
      return Object.assign({}, DEFAULT_DATA, assignData);
    },

    linkId() { return this.linkData.id },

    linkHref() {
      if (this.linkIsDisabled) { return 'javascript:void(0)' }
      return this.linkSetIsEnabled ? this.linkOriginHref : this.linkData.defaultHref;
    },

    linkTarget() {
      if (this.linkIsDisabled) { return null }
      return this.linkSetIsEnabled ? this.linkOriginTarget : this.linkData.defaultTarget;
    },

    linkIsDisabled() {
      return (!this.linkSetIsEnabled || this.disabled);
    },

    linkSetIsEnabled() { return !this.hasLinkData || this.$store.getters['links/enabled'](this.linkId) },
  },



  data() {
    return {
      linkOriginHref  : this.href,
      linkOriginTarget: this.target,
    }
  },
}


// WEBPACK FOOTER //
// ./src/js/ui/mixins/linkset.js